import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import Dropbox from './Dropbox/Dropbox'
import Canvas from './Canvas/Canvas'
import Loader from '../Common/Loader/Loader'
import Modal from '../Common/Modal/Modal'
import Button from '../Common/Buttons/Button/Button'
import { setImageError } from '../../store/actions/image.actions'

export class WorkSpace extends Component {
  static propTypes = {
    forwardDropzoneRef: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    openFileDialog: PropTypes.func.isRequired,
    setImageError: PropTypes.func.isRequired,
    isError: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    i18n: PropTypes.any,
    message: PropTypes.string
  }

  state = {
    fileSize: 0,
  }

  saveImageSize = (fileSize) => {
    this.setState({ fileSize })
  }

  onCloseModal = () => {
    const { setImageError } = this.props
    setImageError(false)
  }

  tryAgain = () => {
    const { openFileDialog } = this.props
    openFileDialog()
    this.onCloseModal()
  }

  render() {
    const { fileSize } = this.state
    const { 
      loading, 
      forwardDropzoneRef, 
      openFileDialog, 
      isError, 
      t, 
      message 
    } = this.props

    return (
      <div className="work-space">
        <Loader 
          isLoading={loading} 
          classes="loader-overlay_work-space" 
          message={message}
        />
        <Dropbox
          forwardDropzoneRef={forwardDropzoneRef}
          openFileDialog={openFileDialog}
          saveImageSize={this.saveImageSize}
        />
        <Canvas fileSize={fileSize} />
        <Modal isOpen={isError} onCloseModal={this.onCloseModal}>
          <div className="modal__body">
            <div className="modal__title">{t('modals.image-error-title')}</div>
            {t('modals.image-error-text')}
            <a className="modal__link">{t('modals.image-error-email')}</a> 
          </div>
          <div className="modal__buttons">
            <Button onClick={this.tryAgain} variant="ghost">
              {t('buttons.open-photo')} 
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({ 
  imageStore: { 
    isError 
  }, 
  loaderStore: { 
    loading, 
    message 
  } 
}) => ({ 
  isError, 
  loading, 
  message 
})

const mapDispatchToProps = (dispatch) => ({
  setImageError: (status) => dispatch(setImageError(status)),
})

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkSpace))
